<template>
  <div v-if="props.label" class="app-step-two-tabs-upload-row__col step-col">
    <p class="app-step-two-tabs-upload-row__title">{{ props.label }}</p>
    <p v-if="hint" class="app-step-two-tabs-upload-row__note">{{ hint }}</p>
  </div>
  <div class="app-step-two-tabs-upload-row__col step-col">
    <div class="app-step-input">
      <app-tooltip v-if="tooltipLabel && tooltipText" style="width: auto">
        <span class="app-step-two-tabs-upload-row__descr">
          {{ tooltipLabel }}
        </span>
        <template #tooltip>
          <p>{{ tooltipText }}</p>
        </template>
      </app-tooltip>
      <textarea
        v-if="textarea"
        :class="{ error: props?.validationModel?.$errors.length }"
        :value="modelValue"
        @input="$emit('update:modelValue', $event.target.value)"
        type="text"
      />

      <input
        v-else
        :class="{ error: props?.validationModel?.$errors.length }"
        :value="modelValue"
        @input="$emit('update:modelValue', $event.target.value)"
        type="text"
      />
      <div class="app-step-input__note">
        <div
          v-for="error in props?.validationModel?.$errors"
          :key="error.$uid"
          class="input-errors"
        >
          <div class="error-message">{{ error.$message }}</div>
        </div>
        {{ leftCharacters }} characters left.
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, watch } from 'vue'
import AppTooltip from '@modules/ui/app-tooltip.vue'

const props = defineProps({
  validationModel: Object,
  validate: Function,
  label: String,
  hint: {
    required: false,
    type: String,
  },
  modelValue: String,
  textarea: Boolean,
  tooltipLabel: {
    required: false,
    type: String,
  },
  tooltipText: {
    required: false,
    type: String,
  },
})

const currentLength = computed(() => props.validationModel?.$model?.length || 0)
const maxLength = computed(() => props.validationModel?.maxLength?.$params?.max)
const leftCharacters = computed(() => maxLength.value - currentLength.value)

watch(leftCharacters, async (left) => {
  if (left > maxLength.value) {
    // await props.validate()
    // props.validationModel.$touch()
    // props.validationModel.$validate()
  }
})
</script>
